import React from 'react';
import {Link} from 'react-router';

type Props = {
  to: string;
  active: string;
  children: React.ReactNode;
};

const TabItem = ({to, active, children}: Props) => (
  <li>
    <Link
      to={to}
      className={
        active === 'true'
          ? '!border-b !border-primary !font-bold !text-primary'
          : 'text-neutral-500'
      }>
      {children}
    </Link>
  </li>
);

export default TabItem;
